import { createFileRoute } from '@tanstack/react-router';
import { marketApi } from '@/lib/api/v2/market';
import { ListPageTemplatePending } from '@/components/v2/page-template-pending';

export const Route = createFileRoute('/_authenticated/market/')({
  // Route-level pending must live HERE: the accurate MarketRoutePending pulls
  // market-products-skeleton → boneyard fixtures (the whole discovery/review/
  // social component tree), so it cannot ship in the entry chunk. This light
  // shell covers only the lazy-chunk download window; the lazy file keeps
  // MarketRoutePending, which overrides it for later pending states.
  pendingComponent: ListPageTemplatePending,
  loader: async ({ context }) => {
    // Prime for intent preloads without blocking the navigation: the lazy
    // component renders its own skeleton and reads this same cache entry, so
    // a client-side navigation never waits on the products fetch.
    // SSR has to await it: rendering the page without the catalogue produced
    // a tree React discarded (hydration mismatch) and briefly told the user
    // "No packages available".
    const products = context.queryClient.ensureQueryData({
      queryKey: ['market', 'products'],
      queryFn: async () => {
        const r = await marketApi.listProducts();
        if (!r.ok) throw new Error(r.error.message);
        return r.value;
      },
    });
    if (typeof window === 'undefined') await products;
  },
});
